<div class="flex flex-col gap-4 w-full">
  <h3
    class="font-bold 'text-lg text-light-300"
    [ngClass]="{ 'text-xl': isStandalone }"
  >
    Bank accounts
  </h3>

  @if(_walletService.isBankAccountsLoading$ | async){
  <ng-container *ngTemplateOutlet="loadingSkeletonBanks" />
  } @else {
  <!--  -->
  @if (isStandalone) {
  <p-card class="w-full">
    <ng-container *ngTemplateOutlet="mainContent" />
  </p-card>
  } @else {
  <ng-container *ngTemplateOutlet="mainContent" />
  }
  <!--  -->
  }
</div>

<ng-template #mainContent>
  <div class="flex flex-col gap-4 w-full">
    @for (bankAccount of bankAccounts; track $index) {
    <!--  -->

    @if(isSelectable){
    <div
      class="flex flex-row items-center gap-2 border border-light-180 rounded-lg p-3 cursor-pointer"
      [ngClass]="{ 'mb-4': $last }"
      (click)="selectedTransactionMethod = bankAccount; onBankAccountSelected()"
    >
      <p-radiobutton
        [value]="bankAccount"
        [(ngModel)]="selectedTransactionMethod"
      />

      <div class="flex flex-row justify-between items-center gap-2 grow">
        <ng-container
          [ngTemplateOutlet]="bankAccountItem"
          [ngTemplateOutletContext]="{
            bankAccount: bankAccount,
            isRemovable: false,
            i: $index
          }"
        />
      </div>
    </div>

    } @else {

    <div
      class="flex flex-row justify-between items-center"
      [ngClass]="{ 'mb-4': $last }"
    >
      <ng-container
        [ngTemplateOutlet]="bankAccountItem"
        [ngTemplateOutletContext]="{
          bankAccount: bankAccount,
          isRemovable: true,
          i: $index
        }"
      />
    </div>

    <!--  -->
    @if(!$last){
    <p-divider />
    }

    <!--  -->
    }

    <!--  -->
    }@empty {
    <div class="flex flex-row gap-2 items-center">
      <div class="w-10 h-10 p-2 bg-light-150 rounded-lg">
        <svg-icon src="assets/icons/bank.svg" svgClass="h-6 w-6" />
      </div>

      <p class="text-sm text-light-200">
        Add a bank account to make transactions from anywhere in the world
      </p>
    </div>
    }

    <p-fluid>
      <p-button
        severity="primary"
        variant="outlined"
        fluid="true"
        (onClick)="onAddNewBankAccountDialog()"
      >
        <svg-icon src="assets/icons/plus.svg" svgClass="h-4 w-4" />
        Add new bank account
      </p-button>
    </p-fluid>
  </div>
</ng-template>

<ng-template #loadingSkeletonBanks>
  <p-card class="w-full">
    <p-skeleton height="50px" width="100%" />
  </p-card>
</ng-template>

<ng-template
  let-bankAccount="bankAccount"
  let-isRemovable="isRemovable"
  let-index="index"
  #bankAccountItem
>
  <div class="flex flex-row gap-3 items-center">
    <svg-icon src="assets/icons/bank.svg" svgClass="h-6 w-6" />

    <span class="text-base text-light-200">
      {{ bankAccount.bankName }}
    </span>
  </div>

  <div class="flex gap-10 items-center">
    <p class="text-sm text-light-200">
      {{ bankAccount.iban }}
    </p>

    @if (isRemovable) {
    <p-button
      variant="text"
      severity="danger"
      [style]="{
        padding: '5px'
      }"
      (onClick)="onRemoveBankAccount(index)"
    >
      <svg-icon
        src="assets/icons/trash-bin.svg"
        svgClass="h-4 w-4 cursor-pointer text-red-100"
      />
    </p-button>
    }
  </div>
</ng-template>

<p-dialog
  header="Add Bank Details"
  [modal]="true"
  [(visible)]="showAddBankAccountDialog"
  styleClass="overflow-hidden"
  [style]="{ width: '512px' }"
>
  <div class="flex flex-col gap-5">
    <p class="text-sm text-light-100 px-1 sm:px-20 text-center">
      You can use your a bank account to transfer money and invest in properties
      on Seedio.
    </p>

    <form
      [formGroup]="addNewBankAccountForm"
      class="flex flex-col items-start gap-5"
      (ngSubmit)="onAddNewBankAccount()"
    >
      <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="accountName">
          Account Holder Name
        </label>

        <input
          id="accountName"
          formControlName="accountName"
          pInputText
          type="text"
          pSize="large"
          placeholder="John Wick"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['accountName'].invalid &&
              fBankAccount['accountName'].touched
          }"
        />

        <p class="font-normal text-xs text-light-60">
          Should match name on bank account.
        </p>
      </div>

      <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="bankName">
          Bank Name
        </label>

        <input
          id="bankName"
          formControlName="bankName"
          pInputText
          type="text"
          pSize="large"
          placeholder="Piraeus Bank"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['bankName'].invalid &&
              fBankAccount['bankName'].touched
          }"
        />
      </div>

      <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="country">
          Country
        </label>

        <p-select
          formControlName="country"
          [options]="countries"
          optionLabel="name"
          placeholder="Select a Country"
          class="w-full"
          size="large"
        />
      </div>

      <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="currency">
          Currency of your bank account
        </label>

        <p-select
          formControlName="currency"
          [options]="currencies"
          optionLabel="label"
          placeholder="Select currency"
          class="w-full"
          size="large"
        />
      </div>

      <!-- <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="branchName">
          Branch Name
        </label>

        <input
          id="branchName"
          formControlName="branchName"
          pInputText
          type="text"
          pSize="large"
          placeholder="Branch Name"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['branchName'].invalid &&
              fBankAccount['branchName'].touched
          }"
        />
      </div> -->

      <!-- <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="accountNumber">
          Account Number
        </label>

        <input
          id="accountNumber"
          formControlName="accountNumber"
          pInputText
          type="text"
          pSize="large"
          placeholder="123456789"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['accountNumber'].invalid &&
              fBankAccount['accountNumber'].touched
          }"
        />
      </div> -->

      <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="iban">
          IBAN
        </label>

        <input
          id="iban"
          formControlName="iban"
          pInputText
          type="text"
          pSize="large"
          placeholder="GR16017012500000000123456789"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['iban'].invalid && fBankAccount['iban'].touched
          }"
        />
      </div>

      <!-- <div class="flex flex-col gap-2 w-full">
        <label class="font-bold text-sm text-light-300" for="swiftCode">
          SWIFT Code
        </label>

        <input
          id="swiftCode"
          formControlName="swiftCode"
          pInputText
          type="text"
          pSize="large"
          placeholder="SWIFT Code"
          class="w-full p-inputtext"
          [style]="{
            'ng-invalid ng-dirty':
              fBankAccount['swiftCode'].invalid &&
              fBankAccount['swiftCode'].touched
          }"
        />
      </div> -->

      <p-fluid>
        <p-button
          type="submit"
          label="Add bank account"
          size="large"
          styleClass="w-full"
          [disabled]="!addNewBankAccountForm['valid']"
          [fluid]="true"
        />
      </p-fluid>

      <p class="text-xs text-light-100 text-center w-full">
        By adding your bank account you agree with our <br />
        <a
          class="underline"
          href="https://drive.google.com/file/d/1mJiu2kNuYfdkEB7xv5ZiTorlKDYDxL-i/view?usp=sharing"
          target="_blank"
          >Terms & Conditions</a
        >
        and
        <a
          class="underline"
          href="https://drive.google.com/file/d/1toUqcggOcAVphFBIt5FMmYYMJYNORpFF/view?usp=sharing"
          target="_blank"
          >Key Risks</a
        >
      </p>

      <!-- [Todo] Weird way to initialize the stylings -->
      <p-inputnumber hidden />
    </form>
  </div>
</p-dialog>
